export interface CalculatedLimitValues {
	xLcl: number;
	xAverage: number;
	xUcl: number;
	rLcl?: number | null;
	rAverage?: number | null;
	rUcl?: number | null;
}

export function applyCalculatedLimits<T extends CalculatedLimitValues>(
	currentValues: T,
	calculatedLimits: CalculatedLimitValues,
): T {
	return {
		...currentValues,
		...calculatedLimits,
		rLcl: calculatedLimits.rLcl ?? null,
		rAverage: calculatedLimits.rAverage ?? null,
		rUcl: calculatedLimits.rUcl ?? null,
	};
}
